import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PosDetailWithOrders } from '../../../../../core/models/pos.model';

@Component({
  selector: 'app-show-qr-code',
  templateUrl: './show-qr-code.component.html',
  styleUrls: ['./show-qr-code.component.scss']
})
export class ShowQrCodeComponent {
  public qrCodeValue: string;
  public tableName: string;

  constructor(
    public dialogRef: MatDialogRef<ShowQrCodeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { pos: PosDetailWithOrders }
  ) {
    this.tableName = data.pos.pos.name;
    this.qrCodeValue = data.pos.pos.token ? data.pos.pos.token.toString() : '';
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
